// extracted by mini-css-extract-plugin
export default {"marquee":"StreamCreditsWidget_marquee__ZI2pK","marqueeinner":"StreamCreditsWidget_marqueeinner__MEjfC"};